// withRouter.tsx
import React from 'react';
import { Location, NavigateFunction, Params, useLocation, useNavigate, useParams } from 'react-router-dom';

export interface WithRouterProps {
  navigate: NavigateFunction;
  location: Location;
  params: Readonly<Params<string>>;
}

export function withRouter<P extends WithRouterProps>(Component: React.ComponentType<P>) {
  return function WrappedWithRouter(props: Omit<P, keyof WithRouterProps>) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Component {...(props as P)} navigate={navigate} location={location} params={params} />;
  };
}
